import React, { useState, useEffect } from 'react';
import { cashWinnerBankDetail } from '../../actions/StudentAction';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { usePrompt } from '../common/usePrompt';

const StudentBankDetail = (props) => {
    const detailUser = props.detail
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

 
    const [amount, setAmount] = useState({ value: '', error: '', isRequired: true });
    const [transactionNumber, setTransactionNumber] = useState({ value: '', error: '', isRequired: true });
    const [transactionDate, setTransactionDate] = useState({ value: '', error: '', isRequired: true });
    const [ibanNumber, setIbanNumber] = useState({ value: '', error: '', isRequired: true });
    const [ifscCode, setIfscCode] = useState({ value: '', error: '', isRequired: true });
    const [swiftCode, setSwiftcode] = useState({ value: '', error: '', isRequired: true });
    const [accountNumber, setAccountNumber] = useState({ value: '', error: '', isRequired: true });
    const [accountHolder, setAccountHolder] = useState({ value: '', error: '', isRequired: true });
    const [bankName, setBankName] = useState({ value: '', error: '', isRequired: true });
    const [branchName, setBranchName] = useState({ value: '', error: '', isRequired: true });
    const [transactionType, setTransactionType] = useState({ value: '', error: '', isRequired: true });
    const [marksheet,setMarksheet] = useState({name:'',value: "",error: "",isRequired: true});
    const [studentPassport,setStudentPassport] = useState({name:'',value: "",error: "",isRequired: true});
    const [parentPassport,setParentPassport] = useState({name:'',value: "",error: "",isRequired: true});
    const [accountHolderType,setAccountHolderType] = useState({name:'',value: "",error: "",isRequired: true});
    const [country,setCountry] = useState({name:'',value: "",error: "",isRequired: true});
    const [registeredMobile,setRegisteredMobile] = useState({name:'',value: "",error: "",isRequired: true});

    const [feeDetail, setFeeDetail] = useState();
    const [userDetail, setUserDetail] = useState();
    const [payType, setPayType] = useState()
    const [actualInstAmt,setActualinstAmt] = useState()
    const [payload,setPayload] = useState()
    const location = useLocation();

    const currentDate = moment().format('YYYY-MM-DD');
    const minDate = moment(currentDate).subtract(7, 'days').format('YYYY-MM-DD');

    const [formIsDirty,setFormIsDirty] = useState(false);

    usePrompt( 'Are you sure you want to leave this page? You have unsaved changes. Do you want to leave?', formIsDirty );

    useEffect(() => {
        const {detail}=props

        if(detail!==undefined){
            setUserDetail(detail)
        }

    },[props.detail])


    // Validations are here  
    const validation = () => {
        let amountRegex = /^\d+(\.\d{1,2})?$/;
        const nameRegex = /^[a-zA-Z() ]+$/;
        let formIsValid = true
      
        if (!accountHolderType.value) {
            formIsValid = false
            let msg = "Please select account holder type"
            setAccountHolderType({ ...accountHolderType, error: msg })
        }
        if (!country.value) {
            formIsValid = false
            let msg = "Please select country"
            setCountry({ ...country, error: msg })
        }
        if (!accountNumber.value) {
            formIsValid = false
            let msg = "Please enter account number"
            setAccountNumber({ ...accountNumber, error: msg })
        }
         if (!amountRegex.test(accountNumber.value)) {
            formIsValid = false
            let msg = "Only numbers should be acceptable No Alphabets";
            setAccountNumber({ ...accountNumber, error: msg })
        }

        if (!accountHolder.value) {
            formIsValid = false
            let msg = "Please enter account holder name"
            setAccountHolder({ ...accountHolder, error: msg })
        }
        if (!ifscCode.value) {
            formIsValid = false
            let msg = "Please enter ifsc code"
            setIfscCode({ ...ifscCode, error: msg })
        }
        if (!swiftCode.value) {
            formIsValid = false
            let msg = "Please enter swift code"
            setSwiftcode({ ...swiftCode, error: msg })
        }
        else if (!nameRegex.test(accountHolder.value)) {
            formIsValid = false
            let msg = "Only Alphabets should be acceptable No numbers";
            setAccountHolder({ ...accountHolder, error: msg })
        }

        if (!bankName.value) {
            formIsValid = false
            let msg = "Please enter account holder name"
            setBankName({ ...bankName, error: msg })
        }
       if (!nameRegex.test(bankName.value)) {
            formIsValid = false
            let msg = "Only Alphabets should be acceptable No numbers";
            setBankName({ ...bankName, error: msg })
        }

        if (!branchName.value) {
            formIsValid = false
            let msg = "Please enter bank branch name"
            setBranchName({ ...branchName, error: msg })
        }
        if (!registeredMobile.value) {
            formIsValid = false
            let msg = "Enter your mobile number registered with bank account"
            setRegisteredMobile({ ...registeredMobile, error: msg })
        }
         if (!nameRegex.test(branchName.value)) {
            formIsValid = false
            let msg = "Only Alphabets should be acceptable No numbers";
            setBranchName({ ...branchName, error: msg })
        }


    
        if (!marksheet.value) {
            formIsValid = false
            let msg = "Please upload marksheet"
            setMarksheet({ ...marksheet, error: msg })
        }
        if (!parentPassport.value) {
            formIsValid = false
            let msg = "Please upload parent passport"
            setParentPassport({ ...parentPassport, error: msg })
        }
        if (!studentPassport.value) {
            formIsValid = false
            let msg = "Please upload student passport"
            setStudentPassport({ ...studentPassport, error: msg })
        }
        


        if (formIsValid) {
            setAccountNumber({ ...accountNumber, error: '' })
            setAccountHolder({ ...accountHolder, error: '' })
            setBankName({ ...bankName, error: '' })
            setIfscCode({ ...ifscCode, error: '' })
            setSwiftcode({ ...swiftCode, error: '' })
            setBranchName({ ...branchName, error: '' })
            setMarksheet({ ...marksheet, error: '' })
            setStudentPassport({ ...studentPassport, error: '' })
            setParentPassport({ ...parentPassport, error: '' })
            setAccountHolderType({ ...accountHolderType, error: '' })
            setCountry({ ...country, error: '' })
            setRegisteredMobile({ ...registeredMobile, error: '' })
        }
        return formIsValid;
    }

    const handleMarksheetChange=(e)=>{
        e.preventDefault();
        let marksheetName=e.target.name
        const value=e.target.files
        setMarksheet({...marksheet,name:marksheetName,value:value[0],error:''})
      }
      const handleStudentPassportChange=(e)=>{
        e.preventDefault();
        let stPassName=e.target.name
        const value=e.target.files
        setStudentPassport({...studentPassport,name:stPassName,value:value[0],error:''})
      }
      const handleParentPassportChange=(e)=>{
        e.preventDefault();
        let ptPassName=e.target.name
        const value=e.target.files
        setParentPassport({...parentPassport,name:ptPassName,value:value[0],error:''})
      }
    

    const onSubmit = async(e) => {
        e.preventDefault();

        if (validation()) {
        setLoading(true)
        const formData = new FormData();
        formData.append('fno',userDetail.form_num)
        formData.append('name',userDetail.name)
        formData.append('country',country.value)
        formData.append('registered_bank_mob',registeredMobile.value)
        formData.append('parent_name',userDetail.father_name)
        formData.append('bank_ifsc',ifscCode.value)
        formData.append('swiftcode',swiftCode.value)
        formData.append('bank_holder_type',accountHolderType.value)
        formData.append('account_holder_name',accountHolder.value)
        formData.append('ind_account_num',accountNumber.value)
        formData.append('bank_name',bankName.value)
        formData.append('bank_branch_name',branchName.value)
        formData.append('marksheet',marksheet.value)
        formData.append('student_passport',studentPassport.value)
        formData.append('parent_passport',parentPassport.value)
        
        
        
        cashWinnerBankDetail(formData).then(res => {
                if (res.status) {
                    setFormIsDirty(false)
                    swal('Bank details submitted successfully','','success')
                    setLoading(false)
                    navigate('/dashboard', { state: {detail:detailUser } });
                }
                else {
                    let msg = res.message ? res.message : 'Something went wrong'
                    swal(msg, '', 'error')
                }
            })
            .catch(err => {
                console.log(err);
            })
        }
        

    }
    return (
        <form onSubmit={onSubmit} className="hold_mandatoryField" encType='multipart/form-data'>
            <div className='row mb-2'>
                <div className='col-lg-12'>
                    <h6 className='text-black fw-bold'>Upload Documents <span className='text-danger fs-4'>*</span></h6>
                </div>
            </div>
            <div className='card p-3 mb-4'>
                <div className='row'>
                    <div className='col-lg-4'>
                        <div className="form-floating diff_fileUpload">
                            <input className="form-control" type="file" name={marksheet.name} 
                            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf" 
                            onChange={(e) => handleMarksheetChange(e)}/>
                            <label className="form-label">Latest Marksheet (Current Grade)</label>
                        </div>
                        {marksheet.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{marksheet.error}</div>}
                    </div>
                    <div className='col-lg-4'>
                        <div className="form-floating diff_fileUpload">
                            <input className="form-control" type="file" name={studentPassport.name} 
                            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf" 
                            onChange={(e) => handleStudentPassportChange(e)}/>
                            <label className="form-label">Student Passport Copy</label>
                        </div>
                        {studentPassport.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{studentPassport.error}</div>}
                    </div>
                    <div className='col-lg-4'>
                        <div className="form-floating diff_fileUpload">
                            <input className="form-control" type="file" name={parentPassport.name} 
                            accept=".png,.gif,.jpeg,.JPEG,.jpg,.pdf" 
                            onChange={(e) => handleParentPassportChange(e)}/>
                            <label className="form-label">Parent Passport Copy</label>
                        </div>
                        {parentPassport.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{parentPassport.error}</div>}
                    </div>

                </div>
            </div>
            <div className='row mb-2'>
                <div className='col-lg-12'>
                    <h6 className='text-black fw-bold'>Bank Details <span className='text-danger fs-4'>*</span></h6>
                </div>
            </div>
            <div className="row mb-4">
            <div className='col-lg-6 mb-3'>
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect" value={country.value}
                            onChange={(e) => {setCountry({ ...country, value: e.target.value, error: '' });setFormIsDirty(true)}} aria-label="Floating label select example">
                            <option value=''>Select Country Of Bank</option>
                            <option value="india">India</option>
                            {/* <option value="parent">Parent</option> */}
                        </select>
                        <label for="floatingSelect">Please Select Country Of Bank</label>
                    </div>
                    {country.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{country.error}</div>}
                </div>
                <div className='col-lg-6 mb-3'>
                    <div className="form-floating">
                        <select className="form-select" id="floatingSelect" value={accountHolderType.value}
                            onChange={(e) => {setAccountHolderType({ ...accountHolderType, value: e.target.value, error: '' });setFormIsDirty(true)}} aria-label="Floating label select example">
                            <option value=''>Please Select Holder Type</option>
                            <option value="student">Student</option>
                            <option value="parent">Parent</option>
                        </select>
                        <label for="floatingSelect">Bank Account Holder Type</label>
                    </div>
                    {accountHolderType.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{accountHolderType.error}</div>}
                </div>
                


                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="text" className="form-control" placeholder="Enter"
                            value={accountHolder.value}
                            onChange={(e) => {setAccountHolder({ ...accountHolder, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="account_holder" />
                        <label for="floatingInput">Account holder name</label>
                    </div>
                    {accountHolder.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{accountHolder.error}</div>}
                </div>
                
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="number" className="form-control" placeholder="Enter"
                            value={accountNumber.value}
                            onChange={(e) => {setAccountNumber({ ...accountNumber, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="account_number" />
                        <label for="floatingInput">Indian Bank Account Number</label>
                    </div>
                    {accountNumber.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{accountNumber.error}</div>}

                </div>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="text" className="form-control" placeholder="Enter"
                            value={ifscCode.value}
                            onChange={(e) => {setIfscCode({ ...ifscCode, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="swift_Code" />
                        <label for="floatingInput">IFSC Code</label>
                    </div>
                    {ifscCode.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{ifscCode.error}</div>}
                </div>

                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="text" className="form-control" placeholder="Enter"
                            value={swiftCode.value}
                            onChange={(e) => {setSwiftcode({ ...swiftCode, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="swift_Code" />
                        <label for="floatingInput">Swift Code</label>
                    </div>
                    {swiftCode.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{swiftCode.error}</div>}
                </div>
                
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="text" className="form-control" placeholder="Enter"
                            value={bankName.value}
                            onChange={(e) => {setBankName({ ...bankName, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="bank_name" />
                        <label for="floatingInput">Bank Name</label>
                    </div>
                    {bankName.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{bankName.error}</div>}
                </div>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="text" className="form-control" placeholder="Enter"
                            value={branchName.value}
                            onChange={(e) => {setBranchName({ ...branchName, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="bank_branch" />
                        <label for="floatingInput">Bank Branch Name</label>
                    </div>
                    {branchName.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{branchName.error}</div>}
                </div>
                <div className="col-lg-6 mb-3">
                    <div className="form-floating">
                        <input type="number" className="form-control" placeholder="Enter"
                            value={registeredMobile.value}
                            onChange={(e) => {setRegisteredMobile({ ...registeredMobile, value: e.target.value, error: '' });setFormIsDirty(true)}}
                            name="account_holder" />
                        <label for="floatingInput">Mobile Number Register with bank account</label>
                    </div>
                    {registeredMobile.error.length > 0 && <div className='invalidFeedback w-100 d-block'>{registeredMobile.error}</div>}
                </div>
    
            </div>
            <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-6 mb-3">
                    {loading ? (<button disabled className="btn btn-primary btn-lg">
                    <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                    Sending ...</button>) : 
                    <button type="submit" className="btn btn-primary btn-lg">Submit</button>
                }
                    {/* <button type="submit" className="btn btn-primary btn-lg">Submit</button> */}
                    <Link to="/dashboard" state={{detail:detailUser}} className="btn btn-warning ms-0 mt-2 mt-lg-0 ms-lg-2 btn-lg">Cancel</Link>
                </div>

            </div>
        </form>
    )
}

export default StudentBankDetail
